module.exports = __webpack_public_path__ + "img/296.1b9231a5.png";